import type { WorkQueueVaCounts } from '../../services/workQueue';
import {
    OPEN_STATUS_OPTIONS,
    type OpenVirtualAppointmentStatus
} from '../virtual-appointments/openVirtualAppointments.ts';

const COUNT_KEYS: Record<OpenVirtualAppointmentStatus, keyof WorkQueueVaCounts> = {
    open: 'open',
    waiting_patient: 'waitingPatient',
    waiting_doctor: 'waitingDoctor'
};

export interface VaStatusCount {
    status: OpenVirtualAppointmentStatus;
    count: number;
}

// Every open status in OPEN_STATUS_OPTIONS order; a missing breakdown counts as zero.
export function vaStatusCounts(counts: WorkQueueVaCounts | undefined): VaStatusCount[] {
    return OPEN_STATUS_OPTIONS.map((status) => ({
        status,
        count: counts?.[COUNT_KEYS[status]] ?? 0
    }));
}
